import { render, staticRenderFns } from "./DodChatMessage.vue?vue&type=template&id=7d95a2aa&scoped=true&"
import script from "./DodChatMessage.vue?vue&type=script&lang=js&"
export * from "./DodChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./DodChatMessage.vue?vue&type=style&index=0&id=7d95a2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95a2aa",
  null
  
)

export default component.exports